<template>
  <div class="enterprise-list-page">
    <div class="container">
      <h1 class="page-title">入驻企业</h1>
      <div class="apply-section">
        <el-button type="primary" size="large" @click="goToApply" class="apply-btn">立即入驻</el-button>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-input v-model="searchKeyword" placeholder="搜索企业名称" @keyup.enter.native="handleSearch" clearable
          @clear="handleSearch">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </div>

      <!-- 企业列表 -->
      <div class="enterprise-grid">
        <el-card v-for="enterprise in enterprises" :key="enterprise.id" class="enterprise-card" shadow="hover"
          @click.native="viewDetail(enterprise.id)">
          <!-- 企业资质略缩图 -->
          <div v-if="enterprise.licenseUrl" class="card-header">
            <el-image :src="enterprise.licenseUrl" fit="cover" class="license-thumb" lazy>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>

          <div class="card-body">
            <div class="enterprise-name">{{ enterprise.name }}</div>
            <div class="enterprise-info">
              <div class="info-item" v-if="enterprise.creditRating">
                <span class="label">信用评级：</span>
                <span class="value">{{ enterprise.creditRating }}</span>
              </div>
              <div class="info-item" v-if="enterprise.registrationDate">
                <span class="label">注册日期：</span>
                <span class="value">{{ enterprise.registrationDate }}</span>
              </div>
              <div class="info-item" v-if="enterprise.legalRepresentative">
                <span class="label">法人代表：</span>
                <span class="value">{{ enterprise.legalRepresentative }}</span>
              </div>
            </div>
            <el-button type="primary" size="small" class="view-btn">查看详情</el-button>
          </div>
        </el-card>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container" v-if="total > 0 && !loading">
        <el-pagination background layout="total, prev, pager, next" :total="total" :current-page.sync="page"
          :page-size="pageSize" @current-change="handlePageChange">
        </el-pagination>
      </div>

      <!-- 加载状态提示 -->
      <div class="loading-status" v-if="loading">
        <p><i class="el-icon-loading"></i> 加载中...</p>
      </div>

      <!-- 空状态 -->
      <el-empty v-if="!loading && enterprises.length === 0" description="暂无企业数据"></el-empty>
    </div>
  </div>
</template>

<script>
import api from '../api/config'

export default {
  name: 'EnterpriseList',
  data() {
    return {
      enterprises: [],
      searchKeyword: '',
      loading: false,
      page: 1,
      pageSize: 12,
      total: 0
    }
  },
  mounted() {
    this.loadEnterprises()
  },
  methods: {
    async loadEnterprises() {
      try {
        this.loading = true

        const endpoint = this.searchKeyword.trim() ? '/enterprises/search' : '/enterprises'
        const params = {
          page: this.page,
          size: this.pageSize
        }
        if (this.searchKeyword.trim()) {
          params.keyword = this.searchKeyword
        }

        const response = await api.get(endpoint, { params })
        this.enterprises = response.data || []
        this.total = response.total || 0
      } catch (error) {
        console.error('加载企业列表失败:', error)
        this.$message.error('加载企业列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page = 1
      this.loadEnterprises()
    },
    handlePageChange(newPage) {
      this.page = newPage
      this.loadEnterprises()
    },
    viewDetail(id) {
      this.$router.push(`/enterprises/${id}`)
    },
    goToApply() {
      this.$router.push('/enterprise/apply')
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 20px;
  background: white;
  padding: 10px;
  border-radius: 8px;
}
.enterprise-list-page {
  min-height: calc(100vh - 216px);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
  }
}

.container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.page-title {
  font-size: 36px;
  text-align: center;
  margin-bottom: 40px;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  font-weight: 600;
}

.search-bar {
  max-width: 600px;
  margin: 0 auto 40px;
}

.apply-section {
  text-align: center;
  margin-bottom: 30px;

  .apply-btn {
    padding: 15px 50px;
    font-size: 18px;
    border-radius: 30px;
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    border: none;
    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);
    transition: all 0.3s;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 20px rgba(245, 87, 108, 0.6);
    }
  }
}

.enterprise-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.enterprise-card {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: none;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);

    .license-thumb {
      transform: scale(1.1);
    }
  }

  ::v-deep .el-card__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .card-header {
    height: 160px;
    overflow: hidden;
    position: relative;
    background: #f0f2f5;

    .license-thumb {
      width: 100%;
      height: 100%;
      transition: transform 0.5s ease;
    }

    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background: #f5f7fa;
      color: #909399;
      font-size: 30px;
    }
  }

  .card-body {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .enterprise-name {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #2c3e50;
    line-height: 1.4;
    height: 2.8em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .enterprise-info {
    margin-bottom: 20px;
    flex: 1;

    .info-item {
      margin-bottom: 8px;
      font-size: 13px;
      display: flex;
      align-items: center;

      .label {
        color: #7f8c8d;
        min-width: 70px;
      }

      .value {
        color: #2c3e50;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .view-btn {
    width: 100%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    border: none;
    border-radius: 8px;
    padding: 10px;
    font-weight: 600;
    transition: all 0.3s ease;

    &:hover {
      opacity: 0.9;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
  }
}

.loading-status {
  text-align: center;
  padding: 20px;
  color: #fff;
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  .page-title {
    font-size: 28px;
  }

  .enterprise-grid {
    grid-template-columns: 1fr;
  }
}
</style>
